import { render, staticRenderFns } from "./radish-list-match.vue?vue&type=template&id=e1c38116"
import script from "./radish-list-match.vue?vue&type=script&lang=js"
export * from "./radish-list-match.vue?vue&type=script&lang=js"
import style0 from "./radish-list-match.vue?vue&type=style&index=0&id=e1c38116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports